import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./lib/font-awesome/css/all.min.css";
import "@rainbow-me/rainbowkit/styles.css";

import React from "react";
import ToasterCard from "./plugins/Toaster";
import AppRoute from "./plugins/router";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./configs/queryClient";

import { WagmiProvider, createConfig, http } from "wagmi";
import { bsc } from "wagmi/chains";
import { RainbowKitProvider, darkTheme, connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  trustWallet,
  coinbaseWallet,
  metaMaskWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";

const projectId = "948bc15a7b5888e5beae17fde670f26a";

// Create a custom BSC chain with public RPC endpoints
const customBsc = {
  ...bsc,
  id: 56,
  name: "Binance Smart Chain",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB",
  },
  rpcUrls: {
    default: { http: ["https://bsc-dataseed.binance.org/"] },
    public: { http: ["https://bsc-dataseed.binance.org/"] },
  },
  blockExplorers: {
    default: { name: "BscScan", url: "https://bscscan.com" },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452,
    },
  },
};

const connectors = connectorsForWallets(
  [
    {
      groupName: "Recommended",
      wallets: [
        () => trustWallet({ projectId }),
        () => coinbaseWallet({ projectId }),
        () => metaMaskWallet({ projectId }),
        () => walletConnectWallet({ projectId }),
      ],
    },
  ],
  {
    projectId,
    appName: "aitellit",
  },
);

const config = createConfig({
  autoConnect: true,
  chains: [customBsc],
  connectors,
  transports: {
    [customBsc.id]: http(),
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={config}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: "#f8780c",
            accentColorForeground: "white",
            borderRadius: "large",
            fontStack: "system",
            overlayBlur: "small",
          })}
          coolMode
          chains={[customBsc]}
        >
          <ToasterCard />
          <AppRoute />
        </RainbowKitProvider>
      </WagmiProvider>
    </QueryClientProvider>
  );
}

export default App;
